import {NgModule} from '@angular/core';
import {ProfileService} from './profile.service';

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
@NgModule({
    providers: [ProfileService]
})
export class ProfileModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/profile/profile.module.ts